import { render, staticRenderFns } from "./logic-error.vue?vue&type=template&id=394488aa&scoped=true&"
import script from "./logic-error.vue?vue&type=script&lang=js&"
export * from "./logic-error.vue?vue&type=script&lang=js&"
import style0 from "./logic-error.vue?vue&type=style&index=0&id=394488aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394488aa",
  null
  
)

export default component.exports